import { useCheckPermissions } from '@/shared';
import { SaveCentroCosto } from '../../components/saveCentroCosto';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateCentroCostoPageInterface {}

const CreateCentroCostoPage: React.FC<CreateCentroCostoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_centrocosto)

  return <SaveCentroCosto titlePage="Crear Centro costo" />;
};

export default CreateCentroCostoPage;
